import { getCombatManager } from "../combat/combatManagerRef.js";
import { narrativeManager } from "../narrative/NarrativeManager.js";

/**
 * In-dungeon save blocking (P08).
 *
 * Save operations are refused while the player is mid-combat or mid-dialogue
 * because neither state round-trips cleanly through `SaveFile`. The function
 * returns `null` when saving is allowed, or a short human-readable reason
 * otherwise — the UI feeds that reason straight into the quicksave log line.
 *
 * Callers should pass the result into `QuicksaveHotkeys.isBlocked`, the
 * save-menu enable check, and `Autosaver` pre-flight checks.
 */

export interface SaveBlockerDeps {
  readonly isInCombat?: () => boolean;
  readonly isNarrativeActive?: () => boolean;
}

export function getSaveBlockReason(deps: SaveBlockerDeps = {}): string | null {
  const inCombat = deps.isInCombat ?? defaultIsInCombat;
  const narrativeActive = deps.isNarrativeActive ?? defaultIsNarrativeActive;

  if (inCombat()) return "in combat";
  if (narrativeActive()) return "in dialogue";
  return null;
}

export function isSaveBlocked(deps: SaveBlockerDeps = {}): boolean {
  return getSaveBlockReason(deps) !== null;
}

function defaultIsInCombat(): boolean {
  const cm = getCombatManager();
  return cm !== null && cm.isInCombat();
}

function defaultIsNarrativeActive(): boolean {
  return narrativeManager.isActive();
}
